import React, { Component } from 'react';
import { asyncConnect } from 'react-async-client';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import Translate from 'react-translate-component';
import { path } from 'ramda';

import RefreshButton from 'components/common/controls/RefreshButton';
import StaticTable from 'components/common/tableComponents/StaticTable';
import { getNewsList } from 'actions/asyncActions';
import { DATE_FORMATS } from 'constants/dateFormats';
import { DateField } from 'components/common/fields/DateTimeFields';
import { fullAutoOptions } from 'constants/asyncClient';
import { NEWS_SIDEBAR } from 'constants/sidebarTypes';
import { SidebarLink } from 'components/common/tableComponents/cellTemplates';
import { notEmpty } from 'utils/ramdaAdditions';
import RangePicker from 'components/common/controls/RangePicker';

const getBriefNews = path(['briefNewsData', 'body']);
const getNewsName = path(['briefNewsData', 'name']);
const getData = data => notEmpty(data) ? data.news : [];

@asyncConnect({
    getNewsList: getNewsList
        .withDefaultPayload(({ dateto, datefrom }) => ({
            dateto: dateto && dateto.format(DATE_FORMATS.parse),
            datefrom: datefrom && datefrom.format(DATE_FORMATS.parse)
        }))
        .withOptions(fullAutoOptions)
})
export default class NewsTable  extends Component {
    static propTypes = {
        datefrom: PropTypes.object,
        dateto: PropTypes.object,
        setDateRange: PropTypes.func.isRequired,
        getNewsList: PropTypes.object.isRequired,
    }

    tableColumns = [
        {
            name: 'number',
            width: 60,
            additionalClass: 'p-l-15',
            template: ({ rowIndex }) => rowIndex + 1
        },
        {
            name: 'name',
            width: 250,
            label: <Translate content="education.news.name" />,
            template: ({ item }) => <SidebarLink
                componentName={NEWS_SIDEBAR}
                item={item}
                value={getNewsName(item)}
            />
        },
        {
            name: 'briefNews',
            label: <Translate content="education.news.briefNews" />,
            width: 500,
            template: ({ item }) => <div dangerouslySetInnerHTML={{__html: getBriefNews(item)}} />
        },
        {
            name: 'date',
            width: 150,
            label: <Translate content="education.news.date" />,
            template: ({ item }) => <DateField date={item.date} />
        }
    ]

    render() {
        const {
            getNewsList: { data, meta, refresh }, setDateRange,
            datefrom, dateto
        } = this.props;

        const value = [datefrom, dateto];

        return (
            <div className="news-table">
                <Row className="react-table-controls list-controls">
                    <Col span={14} className='range-picker m-t-10'>
                        <RangePicker setDateRange={setDateRange} value={value} />
                    </Col>
                    <Col span={10} className="text-right icon-bar">
                        <RefreshButton refreshMeta={meta} handleRefresh={refresh} />
                    </Col>
                </Row>
                <StaticTable
                    meta={meta}
                    refresh={refresh}
                    items={getData(data)}
                    className="width-auto-table"
                    columns={this.tableColumns}
                />
            </div>
        );
    }
}
